import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { buildRouteUrl, detectRoutePlatform, opensInBrowser } from "../../utils/routeUrl";

export const ROUTE_LINK_VARIANT = Object.freeze({
  BADGE: "badge",
  BUTTON: "button",
});

// The badge matches the list-row badges; the labelled button is for touch
// targets such as map popups.
const LINK_CLASS = Object.freeze({
  [ROUTE_LINK_VARIANT.BADGE]: "badge badge-link bg-default text-dark ms-1",
  [ROUTE_LINK_VARIANT.BUTTON]: "btn btn-default btn-sm",
});
const ICON_CLASS = Object.freeze({
  [ROUTE_LINK_VARIANT.BADGE]: "fa fa-route fa-fw",
  [ROUTE_LINK_VARIANT.BUTTON]: "fa fa-route fa-fw me-1",
});
const NEW_TAB_PROPS = Object.freeze({ target: "_blank", rel: "noopener noreferrer" });

export default function RouteLink({ address, variant = ROUTE_LINK_VARIANT.BADGE }) {
  const { t } = useTranslation();
  const platform = detectRoutePlatform();
  const href = buildRouteUrl(address, platform);
  const label = t("common.route_to", { address });
  const text = variant === ROUTE_LINK_VARIANT.BUTTON ? t("common.route") : null;
  const newTabProps = opensInBrowser(platform) ? NEW_TAB_PROPS : {};

  return (
    <a href={href} className={LINK_CLASS[variant]} title={label} aria-label={label} {...newTabProps}>
      <i className={ICON_CLASS[variant]} />
      {text}
    </a>
  );
}

RouteLink.propTypes = {
  address: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(Object.values(ROUTE_LINK_VARIANT)),
};
